import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name face-slightly-frowning
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTBWOSIgLz4KICA8cGF0aCBkPSJNOSAxMFY5IiAvPgogIDxwYXRoIGQ9Ik05IDE2YTUgNSAwIDAxNiAwIiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/face-slightly-frowning
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const FaceSlightlyFrowning: IconNode = [
  ['path', { d: 'M15 10V9' }],
  ['path', { d: 'M9 10V9' }],
  ['path', { d: 'M9 16a5 5 0 016 0' }],
  ['circle', { cx: '12', cy: '12', r: '10' }],
];

export default FaceSlightlyFrowning;
